import React, { useContext } from "react";


function MissionCardLayout({ children }) {


    return (
        <div className="mission-card-layout">
            {children}
        </div>
    )
}

export default MissionCardLayout;